module.exports = __webpack_public_path__ + "static/media/arrow-right-green.5ce4f6df.svg";